import { z } from "zod";
import { ParticipantTypeSchema, RoleSchema } from "./common.js";
import { SupportedCurrencyCodesSchema } from "./currencies.js";
import { ExpenseSchema } from "./expenses.js";
/**
 * Public participant projection used in unauthenticated invite views. Strips
 * `userId` and `claimedAt` so anyone with the public invite URL can render a
 * participant list without learning which slots are bound to TailSpend
 * accounts or when those bindings were made.
 */
export const PublicParticipantSchema = z.strictObject({
    id: z.string().uuid(),
    type: ParticipantTypeSchema,
    displayName: z.string().min(1).max(64),
    role: RoleSchema,
});
/**
 * Read-only group view returned by `GET /groups/{groupId}/invite`. Carries
 * the public group shape plus its participants in the public projection.
 */
export const PublicGroupViewSchema = z.strictObject({
    id: z.string().uuid(),
    label: z.string().min(1).max(120),
    currency: SupportedCurrencyCodesSchema,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    participants: z.array(PublicParticipantSchema),
});
/** Read-only expense view returned by `GET /groups/{groupId}/invite/expenses`. */
export const PublicExpenseSchema = ExpenseSchema;
/** Body of `PATCH /groups/{groupId}/invite`. */
export const UpdateInviteRequestSchema = z.strictObject({
    enabled: z.boolean(),
});
/** Response from `PATCH /groups/{groupId}/invite`. */
export const InviteSchema = z.strictObject({
    groupId: z.string().uuid(),
    enabled: z.boolean(),
    updatedAt: z.string().datetime(),
});
